import { useEffect, useRef } from 'react';
import { Animated, Text, View } from 'react-native';
import { warmupToastStyles as styles } from './WarmupToast.styles';

interface WarmupToastProps {
  message: string | null;
}

export function WarmupToast({ message }: WarmupToastProps) {
  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (message) {
      Animated.timing(opacity, { toValue: 1, duration: 140, useNativeDriver: true }).start();
    } else {
      Animated.timing(opacity, { toValue: 0, duration: 200, useNativeDriver: true }).start();
    }
  }, [message, opacity]);

  if (!message) return null;

  return (
    <View style={styles.wrap} pointerEvents="none">
      <Animated.View style={[styles.pill, { opacity }]}>
        <Text style={styles.text}>{message}</Text>
      </Animated.View>
    </View>
  );
}
